export const  providersList = ["orbet", "sixdot","fitzdares"]
export const  providersFooter = ["orbet", "sixdot"]
export const  providersResponsible = ["orbet", "sixdot"]